import React from 'react';

import { AccessConsumer } from './Context';

const withAccess = WrappedComponent => {
    const WithAccessHOC = props => {
        return (
            <AccessConsumer>
                {permissions => {
                    return <WrappedComponent access={permissions} {...props} />;
                }}
            </AccessConsumer>
        );
    };

    return WithAccessHOC;
};

export default withAccess;
